import { useEffect, useState } from 'react';
import { API_URL } from '../config'; // Ajusta la ruta si tu archivo config está en otro lugar
import { authFetch } from '../utils';

const useGetCameras = () => {
  const [cameras, setCameras] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCameras = async () => {
      try {
        const response = await authFetch(`${API_URL}cameras`);
        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        const data = await response.json();
        setCameras(data);
      } catch (err) {
        console.error('Error al obtener cámaras:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCameras();
  }, []);

  return { cameras, isLoading, error };
};

export default useGetCameras;
